// extracted by mini-css-extract-plugin
export var link = "_ss-0";